export default __webpack_public_path__ + "static/media/utilitarios.d0b228df.png";